import { RefundStatusEnum } from 'common/constants/enum';
import * as React from 'react';

interface Props {
  status: string;
}

export default function useRefundStatus(props: Props) {
  const { status } = props;

  const refundStatus = React.useMemo(() => {
    //processed
    const isProceed = status === RefundStatusEnum.Processed;

    //pending
    const isDraft = status.includes('draft');
    const isPending = status.includes('pending');

    //rejected
    const isRejected = status.includes('reject');

    return {
      isProceed,
      isDraft,
      isPending,
      isRejected,
    };
  }, [status]);

  return { refundStatus };
}
